// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"f8e61a64","312":"e78cd18c","551":"6dbf4956","629":"924be313"}[chunkId] + ".chunk.js";
};